import React from 'react';
import PropTypes from 'prop-types';
import styles from './NewsListModule.module.scss';
import CardNewsFullWidth from '../CardNewsFullWidth';
import Button from '../Button';
import isEmpty from '../../utils/isEmpty';
import i18n from '../../i18n';

const NewsListModule = ({ heading, button, items, filters }) => {
    return (
        <div className={styles['NewsListModule']}>
            <div className={styles['NewsListModule__Content']}>
                {heading && (
                    <h2 className={styles['NewsListModule__Heading']}>
                        {heading}
                    </h2>
                )}
                {items
                    .filter((item) => item.live)
                    .map((item, i) => (
                        <CardNewsFullWidth key={i} {...item} />
                    ))}
            </div>
            {/* {!isEmpty(button) && (
                <div className={styles['NewsListModule__Button']}>
                    <Button
                        text={i18n.t('newsListModule.moreNewsButtonLabel')}
                        {...button}
                    />
                </div>
            )} */}
        </div>
    );
};

NewsListModule.propTypes = {
    heading: PropTypes.string,
    button: PropTypes.object,
    items: PropTypes.array,
};

NewsListModule.defaultProps = {
    heading: null,
    button: {},
    items: [],
};

export default NewsListModule;
